(() => {
  const money = (cents) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const verifiedMonitorSpecs = {
    'msi-monitor-gaming-24-5-180hz-1ms-fhd-ips-rapid-hdr-fhd': ['180 HZ', '1 MS GTG', 'RAPID IPS'],
    'aoc-q27g4xnd-monitor-gaming-27-wqhd-2560x1440-fast-va-180hz-1ms-gtg-hdr10-adaptive-sync-freesync-premium': ['180 HZ', '1 MS GTG', 'FAST VA'],
    'gigabyte-gs27fc2-monitor-gaming-27-full-hd-curvo': ['240 HZ', '1 MS GTG', 'VA 1500R'],
    'dell-se2726hg-monitor-gaming-27-full-hd': ['240 HZ', '0,5 MS GTG', 'FAST IPS'],
    'iiyama-g-master-g2771hsu-b1-monitor-gaming-27-full-hd': ['240 HZ', '0,5 MS MPRT', 'FAST IPS'],
    'aoc-27g4ha-monitor-gaming-27-full-hd': ['200 HZ', '1 MS GTG', 'FAST IPS'],
    'gigabyte-g27q20-monitor-gaming-27-quad-hd': ['200 HZ · 210 HZ OC', '0,5 MS GTG', 'SUPERSPEED IPS'],
    'samsung-g55c-monitor-gaming-27-quad-hd': ['165 HZ', '1 MS MPRT', 'VA 1000R'],
    'iiyama-g-master-gb2771hsu-b1-monitor-gaming-27-full-hd': ['240 HZ', '0,5 MS MPRT', 'FAST IPS'],
    'iiyama-g-master-g2741qsu-b1-monitor-gaming-27-quad-hd': ['144 HZ', '1 MS MPRT', 'IPS'],
    'iiyama-g-master-g2771qs-b1-monitor-gaming-27-quad-hd': ['200 HZ', '0,5 MS MPRT', 'FAST IPS'],
    'iiyama-g-master-gb2741qsu-b1-monitor-gaming-27-quad-hd': ['144 HZ', '1 MS MPRT', 'IPS'],
    'lg-27gs75q-b-monitor-gaming-27-quad-hd': ['180 HZ · 200 HZ OC', '1 MS GTG', 'IPS'],
    'msi-mag-276cpxf-monitor-gaming-27-full-hd': ['280 HZ', '0,5 MS GTG', 'RAPID VA 1500R'],
    'benq-mobiuz-ex251-monitor-gaming-24-5-full-hd': ['220 HZ', '1 MS GTG', 'IPS'],
    'samsung-ls27fg510euxen-monitor-gaming-27-quad-hd': ['180 HZ', '1 MS MPRT', 'VA'],
    'iiyama-g-master-gb2771qsu-b1-monitor-gaming-27-quad-hd': ['200 HZ', '0,5 MS MPRT', 'FAST IPS'],
    'gigabyte-gs27q-x-monitor-gaming-27-quad-hd': ['240 HZ · 250 HZ OC', '1 MS MPRT', 'SUPERSPEED IPS'],
    'asus-tuf-gaming-vg27vqm-monitor-gaming-27-full-hd': ['240 HZ', '1 MS MPRT', 'VA 1500R'],
    'iiyama-gb2795hsu-b1-monitor-gaming-27-full-hd': ['280 HZ', '0,2 MS MPRT', 'VA'],
    'asus-tuf-gaming-vg328qa1a-monitor-gaming-31-5-full-hd': ['170 HZ OC', '1 MS MPRT', 'VA'],
    'lg-32g600a-b-monitor-gaming-32-quad-hd': ['180 HZ', '1 MS GTG', 'VA 1000R'],
    'aoc-cq32g4ve-monitor-gaming-31-5-quad-hd': ['180 HZ', '1 MS GTG · 0,5 MS MPRT', 'FAST VA 1500R'],
    'asus-tuf-gaming-vg32vqm5b-monitor-gaming-31-5-full-hd': ['250 HZ OC', '0,5 MS GTG', 'FAST VA 1500R'],
    'msi-mag-325cqf-monitor-gaming-31-5-quad-hd': ['180 HZ', '0,5 MS GTG', 'RAPID VA 1000R'],
    'gigabyte-m27q2-monitor-gaming-27-quad-hd': ['200 HZ · 210 HZ OC', '1 MS GTG', 'SUPERSPEED IPS'],
    'samsung-ls32fg510euxen-monitor-gaming-32-quad-hd': ['180 HZ', '1 MS MPRT', 'VA'],
    'msi-mag-321cqf-monitor-gaming-31-5-quad-hd': ['180 HZ', '0,5 MS GTG', 'RAPID VA 1500R'],
    'samsung-g55t-monitor-gaming-34-ultrawide-qhd': ['165 HZ', '1 MS MPRT', 'VA 1000R'],
    'asus-tuf-gaming-vg34vqel1a-monitor-gaming-34-ultrawide-qhd': ['100 HZ', '1 MS MPRT', 'VA 1500R'],
    'gigabyte-m27q3-monitor-gaming-27-quad-hd': ['300 HZ · 320 HZ OC', '1 MS GTG', 'SUPERSPEED IPS'],
    'lg-34g600a-b-monitor-gaming-34-ultrawide-qhd': ['160 HZ', '5 MS GTG · 1 MS MBR', 'VA 1800R'],
    'iiyama-g-master-gcb3280qsu-b2-monitor-gaming-31-5-quad-hd': ['180 HZ', '0,2 MS MPRT', 'VA 1500R'],
    'lg-32gs75q-b-monitor-gaming-31-5-quad-hd': ['180 HZ', '1 MS GTG', 'IPS'],
    'gigabyte-m27up-monitor-gaming-27-4k-ultra-hd': ['160 HZ 4K · 320 HZ FHD', '1 MS GTG', 'SUPERSPEED IPS'],
    'lg-34g630a-b-monitor-gaming-34-ultrawide-qhd': ['240 HZ', '1 MS GTG', 'VA 1500R'],
    'samsung-ls27fg500suxen-monitor-gaming-27-quad-hd-oled': ['180 HZ', '0,03 MS GTG', 'QD-OLED'],
    'msi-mag-321cupdf-monitor-gaming-31-5-4k-ultra-hd': ['160 HZ 4K · 320 HZ FHD', '0,5 MS GTG', 'RAPID VA 1500R'],
    'gigabyte-go27q24-monitor-gaming-qd-oled-240-hz': ['240 HZ', '0,03 MS GTG', 'QD-OLED'],
    'aoc-q27g41zdf-monitor-gaming-26-5-quad-hd-qd-oled': ['240 HZ', '0,03 MS GTG', 'QD-OLED'],
    'gigabyte-mo27q2a-monitor-gaming-27-quad-hd-oled': ['280 HZ', '0,03 MS GTG', 'QD-OLED'],
    'lg-27gx704a-b-monitor-gaming-27-quad-hd-oled': ['240 HZ', '0,03 MS GTG', 'OLED MLA+'],
    'asus-rog-strix-xg27aqdmgr-monitor-gaming-26-5-quad-hd-oled': ['240 HZ', '0,03 MS GTG', 'WOLED GLOSSY'],
    'aoc-q27g4zd-monitor-gaming-27-quad-hd-qd-oled': ['280 HZ', '0,03 MS GTG', 'QD-OLED'],
    'samsung-s27dg610su-monitor-gaming-27-quad-hd-oled': ['240 HZ', '0,03 MS GTG', 'OLED'],
    'asus-rog-strix-xg27acdms-monitor-gaming-26-5-quad-hd-qd-oled': ['280 HZ', '0,03 MS GTG', 'QD-OLED'],
    'gigabyte-mo27q3-monitor-gaming-27-quad-hd-oled': ['360 HZ', '0,03 MS GTG', 'QD-OLED'],
    'gigabyte-mo27q28g-monitor-gaming-27-quad-hd-oled': ['280 HZ', '0,03 MS GTG', 'WOLED'],
    'aoc-q27g4sdr-monitor-gaming-26-5-quad-hd-qd-oled': ['360 HZ', '0,03 MS GTG', 'QD-OLED'],
    'asus-rog-strix-xg27acdng-monitor-gaming-26-5-quad-hd-qd-oled': ['360 HZ', '0,03 MS GTG', 'QD-OLED'],
    'msi-mpg-271qrx-monitor-gaming-qd-oled-360-hz': ['360 HZ', '0,03 MS GTG', 'QD-OLED'],
    'asus-rog-strix-xg32ucds-monitor-gaming-31-5-4k-ultra-hd-qd-oled': ['165 HZ', '0,03 MS GTG', 'QD-OLED'],
    'gigabyte-aorus-fo27q5p-monitor-gaming-26-5-quad-hd-oled': ['500 HZ', '0,03 MS GTG', 'QD-OLED'],
    'asus-rog-strix-xg32ucwg-monitor-gaming-31-5-4k-ultra-hd-oled': ['165 HZ 4K · 330 HZ FHD', '0,03 MS GTG', 'WOLED GLOSSY'],
    'msi-mpg-272urx-monitor-gaming-26-5-4k-ultra-hd-qd-oled': ['240 HZ', '0,03 MS GTG', 'QD-OLED'],
    'msi-mpg-341cqpx-monitor-gaming-34-ultrawide-qhd-qd-oled': ['240 HZ', '0,03 MS GTG', 'QD-OLED 1800R'],
    'gigabyte-co49dq-monitor-gaming-dual-qhd-oled-curvo': ['144 HZ', '0,03 MS GTG', 'OLED CURVO'],
    'asus-xg27aqdpg-monitor-gaming-26-5-quad-hd-qd-oled': ['500 HZ', '0,03 MS GTG', 'QD-OLED'],
    'asus-rog-strix-xg32ucwmg-monitor-gaming-31-5-4k-ultra-hd-oled': ['240 HZ 4K · DUAL MODE', '0,03 MS GTG', 'WOLED GLOSSY']
  };

  const verifiedNotebookSpecs = {
    'lenovo-loq-15iax9-notebook-gaming-geforce-rtx-4050-6-gb-16-gb-ddr5-ssd-512-gb-windows-11-home': ['144 HZ', 'NON DICHIARATO', 'IPS FHD'],
    'lenovo-loq-15ahp10-notebook-gaming-geforce-rtx-5050-8-gb-16-gb-ddr5-ssd-512-gb-no-os': ['144–165 HZ', '3 MS SU WQHD', 'IPS'],
    'asus-tuf-gaming-a16-fa608uh-notebook-gaming-geforce-rtx-5050-16-gb-ddr5-ssd-512-gb-windows-11-home': ['165 HZ', '3 MS', 'IPS-LEVEL 16:10'],
    'lenovo-loq-15ahp10-notebook-gaming-geforce-rtx-5050-16-gb-ddr5-ssd-512-gb-windows-11-home': ['144–165 HZ', '3 MS SU WQHD', 'IPS'],
    'msi-cyborg-15-b2rwekg-044xpl-notebook-gaming-geforce-rtx-5050-16-gb-ddr5-ssd-512-gb-no-os': ['144 HZ', 'NON DICHIARATO', 'IPS-LEVEL FHD'],
    'lenovo-loq-15ahp10-notebook-gaming-geforce-rtx-5050-8-gb-32-gb-ddr5-ssd-512-gb-no-os': ['144–165 HZ', '3 MS SU WQHD', 'IPS'],
    'msi-katana-15-b14wek-060xpl-notebook-gaming-geforce-rtx-5050-8-gb-16-gb-ddr5-ssd-512-gb-no-os': ['165 HZ', '2,5 MS', 'IPS-LEVEL QHD'],
    'lenovo-loq-15irx10-notebook-gaming-geforce-rtx-5060-16-gb-ddr5-ssd-512-gb-windows-11-home': ['144 HZ', 'NON DICHIARATO', 'IPS FHD'],
    'msi-cyborg-15-b2rwfkg-038xpl-notebook-gaming-geforce-rtx-5060-16-gb-ddr5-ssd-512-gb-no-os': ['144 HZ', 'NON DICHIARATO', 'IPS-LEVEL FHD'],
    'asus-tuf-gaming-a16-fa608up-notebook-gaming-geforce-rtx-5070-8-gb-16-gb-ddr5-ssd-512-gb-windows-11-home': ['165 HZ', '3 MS', 'IPS-LEVEL 16:10'],
    'msi-katana-15-b14wgk-821xpl-notebook-gaming-geforce-rtx-5070-16-gb-ddr5-ssd-1-tb-no-os': ['144 HZ', 'NON DICHIARATO', 'IPS-LEVEL FHD'],
    'asus-tuf-gaming-f16-fx608jpr-notebook-gaming-geforce-rtx-5070-8-gb-16-gb-ddr5-ssd-1-tb-windows-11-home': ['165 HZ', '3 MS', 'IPS-LEVEL 16:10'],
    'lenovo-legion-pro-5-16adr10-notebook-gaming-geforce-rtx-5060-8-gb-32-gb-ddr5-ssd-1-tb-windows-11-home': ['165–240 HZ', 'NON DICHIARATO', 'IPS / OLED WQXGA'],
    'lenovo-legion-pro-5-16adr10-notebook-gaming-geforce-rtx-5060-8-gb-32-gb-ddr5-ssd-1-tb-no-os': ['165–240 HZ', 'NON DICHIARATO', 'IPS / OLED WQXGA'],
    'lenovo-legion-pro-5-16irx10-notebook-gaming-geforce-rtx-5060-16-gb-ddr5-ssd-1-tb-no-os': ['165–240 HZ', 'NON DICHIARATO', 'IPS / OLED WQXGA'],
    'lenovo-legion-5-15akp10-notebook-gaming-geforce-rtx-5070-8-gb-32-gb-ddr5-ssd-512-gb-schermo-oled-no-os': ['165 HZ', 'NON DICHIARATO', 'OLED WQXGA'],
    'lenovo-legion-5-15akp10-notebook-gaming-geforce-rtx-5070-32-gb-ddr5-ssd-1-tb-no-os': ['165 HZ', 'NON DICHIARATO', 'OLED WQXGA'],
    'lenovo-legion-pro-5-16iax10-notebook-gaming-geforce-rtx-5070-32-gb-ddr5-ssd-1-tb-no-os': ['240 HZ', 'NON DICHIARATO', 'IPS WQXGA'],
    'lenovo-legion-pro-5-16adr10-notebook-gaming-geforce-rtx-5070-8-gb-32-gb-ddr5-ssd-1-tb-no-os': ['165–240 HZ', 'NON DICHIARATO', 'IPS / OLED WQXGA'],
    'asus-rog-strix-g614pr-r9161-notebook-gaming-geforce-rtx-5070-ti-12-gb-16-gb-ddr5-ssd-1-tb-no-os': ['165 HZ', '3 MS', 'IPS-LEVEL WUXGA'],
    'lenovo-legion-pro-5-16iax10-notebook-gaming-geforce-rtx-5070-8-gb-32-gb-ddr5-ssd-1-tb-schermo-oled-windows-11-home': ['165–240 HZ', 'NON DICHIARATO', 'OLED WQXGA'],
    'lenovo-legion-pro-5-16iax10-notebook-gaming-geforce-rtx-5070-32-gb-ddr5-ssd-1-tb-windows-11-home': ['240 HZ', 'NON DICHIARATO', 'IPS WQXGA'],
    'lenovo-legion-pro-5-16iax10-notebook-gaming-geforce-rtx-5070-8-gb-32-gb-ddr5-ssd-1-tb-schermo-oled-no-os': ['165–240 HZ', 'NON DICHIARATO', 'OLED WQXGA'],
    'gigabyte-gaming-notebook-16-165hz-intel-i7-13620h-rtx-5070-8gb-gddr7-32gb-ddr5-ssd-1tb-nvme-windows-11': ['165 HZ', '3 MS', 'IPS 16:10'],
    'lenovo-legion-pro-5-16iax10h-notebook-gaming-geforce-rtx-5070-ti-12-gb-32-gb-ddr5-ssd-1-tb-schermo-oled-no-os': ['165–240 HZ', 'NON DICHIARATO', 'OLED WQXGA'],
    'lenovo-legion-pro-7-16afr10h-notebook-gaming-geforce-rtx-5080-16-gb-64-gb-ddr5-ssd-2-tb-schermo-oled-windows-11-pro': ['240 HZ', 'NON DICHIARATO', 'OLED WQXGA']
  };

  const verifiedAccessorySpecs = {
    'kit-gaming-minimal-gamers-4in1-mouse-rgb-tastiera-rgb-tappetino-cuffie': [
      ['COMPOSIZIONE', '4 PEZZI', 'Tastiera, mouse, cuffie e tappetino inclusi'],
      ['TASTIERA', 'RGB · LAYOUT ITA', 'Tastiera retroilluminata compatta con layout italiano'],
      ['MOUSE', 'RGB · DPI REGOLABILI', 'Sensibilità regolabile e forma ergonomica'],
      ['CUFFIE', 'OVER-EAR · MICROFONO', 'Audio stereo, microfono regolabile e illuminazione RGB'],
      ['TAPPETINO', 'BASE ANTISCIVOLO', 'Superficie scorrevole e base stabile'],
      ['VARIANTI', 'NERO / BIANCO', 'Colorazione selezionabile prima dell’acquisto']
    ],
    'mg-g61-sets-tastiera-meccanica-61-tasti-rgb-mouse-gaming-3200-dpi': [
      ['FORMATO', 'MECCANICA · 61 TASTI', 'Layout compatto 60% per lasciare spazio al mouse'],
      ['ILLUMINAZIONE', 'RGB', 'Retroilluminazione multicolore'],
      ['PRECISIONE', '3200 DPI', 'Quattro livelli: 1200, 1600, 2400 e 3200 DPI'],
      ['PULSANTI', '7 PROGRAMMABILI', 'Comandi configurabili sul mouse'],
      ['SENSORE', 'OTTICO · 8G', 'Fino a 30 IPS di velocità dichiarata'],
      ['CONNESSIONE', 'USB 2.0 · 1,6 M', 'Collegamento cablato plug & play'],
      ['DURATA TASTI', '10 MILIONI', 'Durata dichiarata dei keycap ABS bicolore'],
      ['PESO MOUSE', '131 G', 'Peso dichiarato del mouse']
    ],
    'mg-m96-pro-set-tastiera-wireless-rgb-96-tasti-con-display-digitale-mouse-gaming-wireless-x7-dual-mode-bluetooth-2-4g': [
      ['FORMATO', '96 TASTI', 'Layout completo ma compatto'],
      ['CONNESSIONE', 'BLUETOOTH 5.0 + 2.4G', 'Dual mode wireless e collegamento multi-dispositivo'],
      ['DISPLAY', 'DIGITALE', 'Stato di batteria, connessione e dispositivo'],
      ['CONTROLLO', 'MANOPOLA MULTIFUNZIONE', 'Accesso rapido a volume e funzioni principali'],
      ['ILLUMINAZIONE', 'RGB', 'Effetti e colori personalizzabili'],
      ['PRECISIONE', '3200 DPI', 'Sensore ottico regolabile del mouse X7'],
      ['BATTERIA', 'RICARICABILE', 'Alimentazione pensata per sessioni prolungate'],
      ['COMPATIBILITÀ', 'WIN · MAC · ANDROID · IOS', 'Compatibile con desktop, notebook e dispositivi mobili']
    ]
  };

  function detectSpecs(title, tags, type, description, handle) {
    const source = clean([title, tags, type, description].join(' '))
      .replace(/(\d+)\s*Go\b/gi, '$1 GB')
      .replace(/(\d+)\s*To\b/gi, '$1 TB');
    const category = clean([title, type, handle].join(' ')).toLowerCase();
    const isDisplay = /(monitor|display|notebook|laptop|smart tv|televisore|\btv\b)/i.test(category);
    const isTv = /(smart tv|televisore|\btv\b)/i.test(category);
    const isNotebook = /(notebook|laptop)/i.test(category);
    const isAccessory = /(mouse|tastier|keyboard|cuff|headset|sedia|chair|kit gaming)/i.test(category);
    const specs = [];
    const add = (label, value, detail) => {
      const normalized = clean(value);
      if (!normalized || specs.some((item) => item.label === label || item.value.toLowerCase() === normalized.toLowerCase())) return;
      specs.push({ label, value: normalized.toUpperCase(), detail });
    };
    const match = (regex, group = 1) => (source.match(regex) || [])[group] || '';
    const normalizedHandle = String(handle || '').toLowerCase();
    const verified = verifiedMonitorSpecs[normalizedHandle] || verifiedNotebookSpecs[normalizedHandle];
    const verifiedAccessory = verifiedAccessorySpecs[normalizedHandle];

    if (verifiedAccessory) {
      verifiedAccessory.forEach(([label, value, detail]) => add(label, value, detail));
    }

    if (verified) {
      add('REFRESH RATE', verified[0], 'Frequenza verificata sulla documentazione ufficiale del modello');
      add('RISPOSTA', verified[1], verified[1] === 'NON DICHIARATO' ? 'Il produttore non pubblica un valore in millisecondi per questa configurazione' : 'Tempo di risposta dichiarato dal produttore');
      add('PANNELLO', verified[2], 'Tecnologia e formato del pannello');
    }

    if (isDisplay) {
      add('DIAGONALE', match(/(\d{2}(?:[.,]\d)?)\s*(?:"|”|POLLICI)/i), 'Dimensione dello schermo in pollici');
      add('RISOLUZIONE', match(/(DUAL\s*QHD|ULTRAWIDE\s*QHD|WQHD|QUAD\s*HD|QHD|4K\s*ULTRA\s*HD|4K|FULL\s*HD|FHD)/i), 'Definizione nativa del pannello');
      if (isTv) {
        add('TECNOLOGIA', match(/(QD[-\s]?OLED|MINI\s*LED|QLED|OLED|DIRECT\s*LED|EDGE\s*LED|LED)/i), 'Tecnologia del pannello e della retroilluminazione');
        add('REFRESH RATE', match(/(?:REFRESH(?:\s+E\s+GAMING)?|FREQUENZA|PANNELLO)\s*:?\s*(\d{2,3}\s*HZ)/i) || (match(/VRR\s*(?:FINO\s*A)?\s*(\d{2,3}\s*HZ)/i)), 'Frequenza nativa o limite VRR dichiarato per il modello');
        add('HDR', match(/(DOLBY\s*VISION|HDR10\+?\s*ADAPTIVE|HDR10\+?|HDR10\s*PRO|HLG)/i), 'Formato HDR principale supportato');
        add('SMART TV', match(/(WEBOS\s*\d{2}|GOOGLE\s*TV|ANDROID\s*TV|TIZEN|ROKU\s*TV|VIDAA\s*U?\d*)/i), 'Piattaforma smart integrata');
        const hdmi = match(/(\d+)\s*(?:X\s*)?HDMI/i);
        const usb = match(/(\d+)\s*(?:X\s*)?USB/i);
        add('CONNESSIONI', [hdmi ? hdmi + ' HDMI' : '', usb ? usb + ' USB' : ''].filter(Boolean).join(' · '), 'Ingressi principali indicati nella scheda tecnica');
        const gaming = ['VRR', 'ALLM', 'GAME OPTIMIZER', 'GAME MODE'].filter((feature) => new RegExp('\\b' + feature.replace(' ', '\\s+') + '\\b', 'i').test(source));
        add('GAMING', gaming.join(' · '), 'Funzioni dedicate a console e gioco');
      }
      if (!verified) {
        add('REFRESH RATE', match(/(\d{2,3})\s*HZ/i) ? match(/(\d{2,3})\s*HZ/i) + ' HZ' : '', 'Più Hz significano movimento più fluido');
        add('RISPOSTA', match(/(\d(?:[.,]\d+)?)\s*MS/i) ? match(/(\d(?:[.,]\d+)?)\s*MS/i) + ' MS' : '', 'Tempo di risposta dichiarato');
        add('PANNELLO', match(/(QD[-\s]?OLED|MINI\s*LED|QLED|OLED|DIRECT\s*LED|EDGE\s*LED|RAPID\s*IPS|FAST\s*IPS|IPS|FAST\s*VA|\bVA\b|\bTN\b|LED)/i), 'Tecnologia del pannello');
      }
    }
    if (isAccessory && !verifiedAccessory) {
      const dpi = match(/(\d{1,3}(?:[.\s]\d{3})?|\d{4,5})\s*DPI/i);
      const warranty = match(/GARANZIA:\s*(\d+)\s*MESI/i);
      add('PRECISIONE', dpi ? dpi + ' DPI' : '', 'Sensibilità massima dichiarata');
      add('CONNESSIONE', match(/(WIRELESS(?:\s+(?:RF\s+)?LIGHTSPEED)?|BLUETOOTH(?:\s*\d(?:\.\d)?)?|CON CAVO|DUAL MODE(?:\s*\([^)]*\))?)/i), 'Tipo di collegamento');
      add('FORMATO', match(/(MECCANICA|TENKEYLESS|TKL|LOW PROFILE|61 TASTI|96 TASTI|OVER-EAR|7\.1|MULTIPIATTAFORMA|PER XBOX)/i), 'Formato o caratteristica d’uso principale');
      add('ILLUMINAZIONE', match(/(RGB(?:\s*LIGHTSYNC)?|ILLUMINAT[OA])/i), 'Sistema di illuminazione dichiarato');
      add('SENSORE', match(/(OTTICO|HERO\s*\d*K?)/i), 'Tecnologia di rilevamento');
      add('MODELLO', match(/MODELLO:\s*(.+?)(?=CODICE ARTICOLO:|TIPO:|CONNESSIONE:|ILLUMINAZIONE:|SENSORE:|RISOLUZIONE:|IMPUGNATURA:|COMPATIBILIT[AÀ]:|COLORE:|GARANZIA:|NUOVO)/i), 'Modello esatto del produttore');
      add('GARANZIA', warranty ? warranty + ' MESI' : '', 'Copertura indicata per il prodotto');
    }
    add('SCHEDA VIDEO', match(/((?:GEFORCE\s+)?RTX\s*\d{4}(?:\s*TI)?|RADEON\s+RX\s*\d{4}(?:\s*XT)?|ARC\s+[A-Z]\d{3})/i), 'GPU dedicata o integrata');
    add('PROCESSORE', match(/((?:INTEL\s+)?(?:CORE\s+)?I[3579](?:[\s-]?\d{4,5}[A-Z0-9]*|\s+\d{1,2}ª?\s*GEN)|(?:AMD\s+)?RYZEN\s+[3579]\s+\d{4}[A-Z0-9]*)/i), 'Processore principale');
    const memory = match(/(\d+\s*GB(?:\s*DDR[45])?)\s+(?:(?:DI|DE)\s+)?RAM/i)
      || match(/(?:RAM|MEMORIA\s+DI\s+SISTEMA)\s*[:\-]?\s*(\d+\s*GB(?:\s*DDR[45])?)/i)
      || match(/(\d+\s*GB\s*DDR[45])/i)
      || match(/(\d+\s*GB)(?=\s+\d+\s*(?:TB|GB)\s*(?:SSD|NVME))/i);
    add('MEMORIA', memory, 'Memoria di sistema inclusa');
    add('ARCHIVIAZIONE', match(/(?:SSD|NVME|M\.2)[^\d]{0,12}(\d+\s*(?:TB|GB))/i), 'Spazio di archiviazione veloce');
    add('CONNETTIVITÀ', match(/(WI[-\s]?FI\s*\d?|BLUETOOTH\s*\d(?:\.\d)?)/i), 'Connessione senza fili');
    if (isNotebook) {
      add('DISPLAY', /\bTOUCH(?:SCREEN)?\b/i.test(source) ? 'TOUCH' : '', 'Schermo tattile indicato per questa configurazione');
      add('SISTEMA', match(/(WINDOWS\s*11\s*(?:PRO|HOME)?|WINDOWS\s*10\s*(?:PRO|HOME)?|NO\s*OS|SENZA\s*SISTEMA\s*OPERATIVO)/i), 'Sistema operativo incluso o assente come dichiarato');
      add('STATO', /RICONDIZIONAT[OA]|REFURBISHED/i.test(source) ? (match(/(RICONDIZIONAT[OA](?:\s+GRADO\s+[A-C])?)/i) || 'RICONDIZIONATO') : (/\bNUOV[OA]\b/i.test(source) ? 'NUOVO' : ''), 'Condizione commerciale dichiarata');
    }
    return specs.slice(0, 8);
  }

  function renderChips(container, specs) {
    if (!container || !specs.length) return;
    container.textContent = '';
    specs.slice(0, 5).forEach((spec) => {
      const chip = document.createElement('span');
      chip.textContent = spec.value;
      container.append(chip);
    });
  }

  function renderSpecs(container, specs) {
    if (!container || !specs.length) return;
    specs.forEach((spec) => {
      const card = document.createElement('article');
      const label = document.createElement('small');
      const value = document.createElement('b');
      const detail = document.createElement('p');
      label.textContent = spec.label;
      value.textContent = spec.value;
      detail.textContent = spec.detail;
      card.append(label, value, detail);
      container.append(card);
    });
  }

  function initProduct(root) {
    if (root.dataset.mgStandardReady === 'true') return;
    root.dataset.mgStandardReady = 'true';
    const specs = detectSpecs(root.dataset.productTitle, root.dataset.productTags, root.dataset.productType, root.dataset.productDescription, root.dataset.productHandle);
    renderChips(root.querySelector('[data-mg-tech-summary]'), specs);
    renderSpecs(root.querySelector('[data-mg-standard-specs]'), specs);

    const isGamingPc = /pc gaming/i.test(clean([root.dataset.productTitle, root.dataset.productType].join(' ')));
    const isGamingNotebook = /(gaming.*(?:notebook|laptop)|(?:notebook|laptop).*gaming)/i.test(clean([root.dataset.productTitle, root.dataset.productTags, root.dataset.productType].join(' ')));
    const featureLine = specs.slice(0, 5).map((item) => item.value).join(', ');
    const emotionalDetail = root.querySelector('[data-mg-standard-emotional-detail]');
    const emotionalLocked = root.dataset.mgEmotionalLocked === 'true';
    if (emotionalDetail && featureLine && !emotionalLocked) {
      emotionalDetail.textContent = isGamingPc
        ? featureLine + ': questa è la configurazione base inclusa nel prezzo. È pronta per Fortnite, Warzone, Valorant, GTA V/FiveM e i titoli più giocati; al PASSO 2 puoi personalizzare componenti e capacità. Al checkout aggiungi Minimal Booster per ottimizzazione, stress test e profilo su misura.'
        : isGamingNotebook
          ? featureLine + ': questa è la configurazione dichiarata inclusa nel prezzo. È pronta per Fortnite, Warzone, Valorant, Rocket League e per trovare il giusto equilibrio nei titoli più pesanti; al PASSO 2 trovi il quadro tecnico completo e le eventuali opzioni disponibili.'
          : featureLine + ': sono i dati che definiscono il carattere di questo prodotto e il motivo per cui può fare la differenza nel tuo setup.';
    }
    if (isGamingPc) {
      const strength = specs.filter((item) => ['SCHEDA VIDEO', 'PROCESSORE'].includes(item.label)).map((item) => item.value).join(' + ');
      const storyCopy = root.querySelector('.mg-standard-emotion > div:last-child');
      if (storyCopy && strength && !storyCopy.querySelector('.mg-standard-strength')) {
        const panel = document.createElement('div');
        panel.className = 'mg-standard-strength';
        panel.innerHTML = '<i aria-hidden="true">◆</i><span><small>IL SUO PUNTO FORTE</small><b></b></span>';
        panel.querySelector('b').textContent = strength;
        storyCopy.append(panel);
      }
    }

    const mainImage = root.querySelector('[data-mg-standard-main-image]');
    root.querySelectorAll('[data-mg-standard-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (mainImage && button.dataset.imageSrc) mainImage.src = button.dataset.imageSrc;
        root.querySelectorAll('[data-mg-standard-thumb]').forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });

    const variant = root.querySelector('[data-mg-standard-variant]');
    variant?.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      const price = root.querySelector('[data-mg-standard-price]');
      const compare = root.querySelector('[data-mg-standard-compare]');
      if (price) price.textContent = money(option.dataset.price);
      if (compare) {
        const compareValue = Number(option.dataset.compare || 0);
        compare.textContent = money(compareValue);
        compare.hidden = compareValue <= Number(option.dataset.price || 0);
      }
    });
  }

  function initTechCards(scope = document) {
    scope.querySelectorAll('[data-mg-tech-card]').forEach((card) => {
      if (card.dataset.mgTechReady === 'true') return;
      card.dataset.mgTechReady = 'true';
      const cardCategory = clean([card.dataset.productTitle, card.dataset.productTags, card.dataset.productType].join(' '));
      const isNotebookCard = /(notebook|laptop)/i.test(cardCategory);
      const isGamingNotebookCard = /(gaming.*(?:notebook|laptop)|(?:notebook|laptop).*gaming)/i.test(cardCategory);
      const detected = detectSpecs(card.dataset.productTitle, card.dataset.productTags, card.dataset.productType, card.dataset.productDescription, card.dataset.productHandle);
      const cardSpecs = isNotebookCard && !isGamingNotebookCard ? detected.filter((item) => item.label !== 'PANNELLO') : detected;
      renderChips(card.querySelector('[data-mg-tech-summary]'), cardSpecs);
    });
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mg-standard-product]').forEach(initProduct);
    initTechCards(scope);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
